import Loading from "@/components/GlobalLoading/Loading";
import WeChatMask from "@/containers/common/WeChatMask";
import RFLayout from "@/layout/RFLayout";
import { AppDownLoadAddress } from "@/utils/confiigUtils";
import { isIos, isMac, isWeixin } from "@/utils/parserDevice";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ReactElement, useEffect, useState } from "react";

export default function IntentRockflow() {
	const [visible, setVisible] = useState(false);
	useEffect(() => {
		if (isWeixin()) {
			setVisible(true);
			return;
		}

		const isMacOrIos = isMac() || isIos();
		if (isMacOrIos) {
			window.location.replace(AppDownLoadAddress.APP_STORE);
		} else {
			window.location.replace(AppDownLoadAddress.GOOGLE_PALY);
		}
	}, []);

	return (
		<div className="w-full h-full">
			<Loading />
			<WeChatMask visible={visible} onClose={() => {}} />
		</div>
	);
}

export const getServerSideProps: GetServerSideProps = async ({ locale = "en" }) => {
	return {
		props: {
			...(await serverSideTranslations(locale, ["common"])),

			locale: locale,
		},
	};
};

IntentRockflow.getLayout = function (page: ReactElement) {
	return <RFLayout>{page}</RFLayout>;
};
